import React from 'react';
import { Link } from 'react-router';

import Metadata from 'components/Metadata'
import IconBNB from 'assets/icons/BNBblack.svg';
import IconMATIC from 'assets/icons/MATIC.svg';
import IconBTC from 'assets/icons/BTC.svg';
import IconDOGE from 'assets/icons/DOGE.svg';
import IconWDOGE from 'assets/icons/wDOGE.svg';
import IconBSC from 'assets/icons/BSC.svg';
import IconDogeChain from 'assets/icons/wDOGE.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as CrystalBallIcon } from 'assets/icons/CrystalBallIcon.svg';
import './catalogue.scss';


/* eslint-disable jsx-a11y/alt-text */
function PredictionCatalogue(props) {
  const games = [
    {
      icon: <img src={IconBTC} className='' alt='BTC icon' />,
      chainIcon: <img src={IconBSC} className='' alt='BSC icon' />,
      name: 'BTC',
      chain: 'BSC',
      link: '/bsc/btc'
    },
    {
      icon: <img src={IconBNB} className='' alt='BNB icon' />,
      chainIcon: <img src={IconBSC} className='' alt='BSC icon' />,
      name: 'BNB',
      chain: 'BSC',
      link: '/bsc/bnb'
    },
    /*
    {
      icon: <img src={IconDOGE} className='' alt='DOGE icon' />,
      chainIcon: <img src={IconDogeChain} className='' alt='DogeChain icon' />,
      name: 'DOGE',
      chain: 'DogeChain',
      link: '/dc/doge'
    },
    {
      icon: <img src={IconBTC} className='' alt='BTC icon' />,
      chainIcon: <img src={IconDogeChain} className='' alt='DogeChain icon' />,
      name: 'BTC',
      chain: 'DogeChain',
      link: '/dc/btc'
    },
    */
  ];
  /* eslint-enable jsx-a11y/alt-text */


  return (<div className='GamesCatalogue'>
    <Metadata title="All prediction games" link="/prediction"/>
    <h1>Prediction Games</h1>
    {games.map((item, index) => {
      const currencyWithoutChain = item.link.substring(item.link.lastIndexOf('/'))
      //const chartURL = '/chart' + currencyWithoutChain;

      return (<div key={index} className='ThemeCardBase CatalogueItem'>
        <div>
          <div className='Group Currency'>
            <div className='Subgroup'>
              <p></p> {/* used to say "PREDICT" */}
              {item.icon}
            </div>
            <p>{item.name}</p>
          </div>
          <div className='Group Chain'>
            <div className='Subgroup'>
              <p className='Dark'></p> {/* used to say "CHAIN" */}
              {item.chainIcon}
            </div>
            <p>{item.chain}</p>
          </div>
          <div className='Buttons'>
            <Link id='Prediction' className='ThemeButton' to={'/prediction' + item.link}>
              <CrystalBallIcon className='Icon' />
              <p>Game</p>
            </Link>
            {/*
            <Link id='Chart' className='' to={chartURL}>
              <FontAwesomeIcon className='Icon' icon={faChartColumn} />
              Chart
            </Link>
            */}
            <Link id='History' className='ThemeButton' to={'/history' + item.link}>
              <FontAwesomeIcon className='Icon' icon={faClockRotateLeft} />
              <p>History</p>
            </Link>
          </div>
        </div>
      </div>);
    })}
    {/*
    <a className='LiveEventsLink' href={'https://live-events.' + DOMAIN_NAME} target='_blank' rel='noopener noreferrer'>
      <p>Live Events</p>
      <LiveEventsCarousel />
    </a>
  */}
  </div>);
}

export default PredictionCatalogue;
